import { useState, useCallback } from 'react';

export default () => {
    const [order, setOrder] = useState<API_ORDER.OrderItem>();

    // 增加数量
    const upDataOrder = useCallback((value: any) => {
        setOrder(value);
    }, []);

    return {
        order,
        upDataOrder,
    };
};
